import {ReactNode} from 'react'
import {StyledPageHeaderContainer, StyledPageHeaderText} from '@components/commons/page-hero/style.ts'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

interface PageHeaderProps {
    title: string
    subtitle?: string | null
    sideComponent?: ReactNode
}

export const PageHero = ({title, subtitle, sideComponent}: PageHeaderProps) => {
    return (
        <StyledPageHeaderContainer>
            <StyledPageHeaderText>
                <Flexbox align={'center'} gap={2}>
                    <h1>{title}</h1>
                </Flexbox>
                {subtitle && <p>{subtitle}</p>}
            </StyledPageHeaderText>
            {sideComponent && <div>{sideComponent}</div>}
        </StyledPageHeaderContainer>
    )
}

PageHero.displayName = 'PageHero'
